<template>
  <portlet
    :icon="'fad fa-exclamation-triangle'"
    :title="'Blacklist'"
    :actionsBlock="true"
  >
    <template slot="portletBody">
      <form v-if="Can(rights.BLACKLIST_ADD)" @submit.prevent="addBlacklistedCandidate()">
        <div class="row align-items-end">
          <div class="form-group col-sm-6 col-lg-4">
            <label for="blacklistedCandidate-firstName">Voornaam</label>
            <input
              required
              name="blacklistedCandidate-firstName"
              id="blacklistedCandidate-firstName"
              type="text"
              class="form-control"
              v-model="blacklistedCandidate.firstName"
            />
          </div>
          <div class="form-group col-sm-6  col-lg-4">
            <label for="blacklistedCandidate-lastName">Achternaam</label>
            <input
              required
              name="blacklistedCandidate-lastName"
              id="blacklistedCandidate-lastName"
              type="text"
              class="form-control"
              v-model="blacklistedCandidate.lastName"
            />
          </div>
          <div class="form-group col-sm-6  col-lg-2">
            <label for="blacklistedCandidate-birthdate">Geboortedatum</label>
            <input
              required
              name="blacklistedCandidate-birthdate"
              id="blacklistedCandidate-birthdate"
              type="date"
              max="2999-12-30"
              format="dd-MM-yyyy"
              class="form-control placeholder-date"
              v-model="blacklistedCandidate.birthdate"
            />
          </div>
          <div class="form-group col-sm-6  col-lg-2 blacklist-save">
            <button class="btn btn-primary btn-block">Toevoegen</button>
          </div>
        </div>
      </form>

      <datatables
        :tableClass="tableClass"
        v-if="getBlacklist.length && renderedComponent && Can(rights.BLACKLIST_VIEW)"
        :rows="getBlacklist"
        :columns="getColumns()"
        tableID="blacklist"
        :tableInitOptions="tableInitOptions"
        routerLinkClass="dt-router-link"
        :deleteFunction="deleteBlacklistedCandidate"
        deleteClass="delete"
        :getDataClass="'get-data'"
        @rowSelected="rowSelected"
      ></datatables>

      <edit-blacklisted-candidate
        v-if="blacklistedCandidate"
        :title="'Blacklist kandidaat aanpassen'"
        :value="blacklistedCandidate"
        :name="modalId"
        @saveChanges="editBlacklistedCandidate($event)"
      ></edit-blacklisted-candidate>
    </template>
  </portlet>
</template>

<script>
  import {mapGetters} from "vuex";
  import editBlacklistedCandidate from "../../components/editBlacklistedCandidate";
  import {dataTables} from "../../components/mixins/dataTables";
  import {swalModals} from "../../components/mixins/swalModals.js";
  import { Can } from "../../../permission/ability.js";
  import { RIGHTS } from "../roles/rights.js";

  export default {
    mixins: [dataTables, swalModals],
    components: {editBlacklistedCandidate},
    data() {
      return {
        isAdmin: false,
        modalId: null,
        rights: '',
        blacklistedCandidate: {
          firstName: null,
          lastName: null,
          birthdate: null,
          blacklistedBy: null
        },
      };
    },
    methods: {
      Can,
      getColumns() {
        let self = this;
        return [
          {
            data: null, name: 'Voornaam', visible: true, searchable: true, responsivePriority: 1,
            render(data) {
              if (data.candidateId) {
                return '<a data-to="/candidates/' + data.candidateId + '" class="dt-router-link">' + data.firstName + '</a>'
              } else {
                return data.firstName;
              }
            }
          },
          {data: 'lastName', name: 'Achternaam', visible: true, searchable: true},
          {
            data: null, name: 'Geboortedatum', visible: true, searchable: true,
            render(data) {
              return moment(data.birthdate).format('DD-MM-YYYY')
            }
          },
          {data: 'blacklistedBy', name: 'Geblacklist door', visible: true, searchable: true},
          {
            data: null, name: 'Opties', orderable: false, responsivePriority: 2,
            render(data) {
              var options = '';

              if(Can(RIGHTS.BLACKLIST_EDIT)) {
                if(data.candidateId) {
                  options += '<a data-to="/candidates/' + data.candidateId + '" class="dt-router-link"><i title="Persoon bekijken" class="far fa-user action-icon"></i></a>';
                } else {
                  options += '<i title="Black aanpassen" class="far fa-edit action-icon get-data" data-target="#' + data.id + '" data-toggle="modal"></i>';
                }
              }

              if(Can(RIGHTS.BLACKLIST_DELETE)) {
                options += '<a class="delete action-icon dt-router-link" data-id="' + data.id + '"><i title="Verwijder" class="far fa-trash-alt delete"></i></a>';
              }

              if(options === '') {
                options += '<i title="Persoon aanpassen" class="far fa-edit action-icon get-data" data-target="#' + data.id + '" data-toggle="modal"></i>';
              }
              
              return options;
            }
          },
        ]
      },

      rowSelected(value) {
        this.modalId = value.id;
        this.blacklistedCandidate = {
          id: this.modalId,
          firstName: value.firstName,
          lastName: value.lastName,
          birthdate: value.birthdate
        };
      },

      addBlacklistedCandidate() {
        this.blacklistedCandidate.blacklistedBy = this.$store.state.users.me.firstname + ' ' + this.$store.state.users.me.lastname
        this.blacklistedCandidate.department = this.$store.state.users.me.selectedDepartment;
        this.$store.dispatch("blacklist/set", this.blacklistedCandidate).then(() => {
          this.$toasted.global.successRequest({
            message: "Blacklist persoon aangemaakt"
          });
          this.blacklistedCandidate = {};
          this.renderComponent();
        }).catch(() => {
          this.$toasted.global.failedRequest();
        });

        this.$validator.reset();
      },

      editBlacklistedCandidate(blacklistedCandidate) {
        if (blacklistedCandidate.firstName) {
          let id = blacklistedCandidate.id;

          $(".modal").modal("hide");
          $(".modal-backdrop").remove();

          this.$toasted.global.successRequest({
            message: "Blacklist persoon aangepast"
          });
          this.$store.dispatch("blacklist/set", {
            id,
            firstName: blacklistedCandidate.firstName,
            lastName: blacklistedCandidate.lastName,
            birthdate: blacklistedCandidate.birthdate
          });

          this.renderComponent();
        }
      },

      deleteBlacklistedCandidate(blacklistedCandidate) {
        this.blacklistedCandidate = blacklistedCandidate;
        let id = blacklistedCandidate.id;
        this.swalDelete(this.blacklistedCandidateName).then(result => {
          if (result.value) {
            this.$store.dispatch("blacklist/delete", id);

            this.$toasted.global.successRequest({
              message: "Persoon verwijderd"
            });

            this.renderComponent();

            if (blacklistedCandidate.candidateId) {
              let candidId = blacklistedCandidate.candidateId
              this.$FB.collection('candidates').doc(candidId).update({
                blacklisted: false
              })
            }
          }
        });
        this.blacklistedCandidate = {};
      }
    },
    computed: {
      ...mapGetters("blacklist", ["getBlacklist"]),
      blacklistedCandidateName() {
        return (this.blacklistedCandidate.firstName + " " + this.blacklistedCandidate.lastName);
      }
    },
    created() {
      this.rights = RIGHTS;
      this.isAdmin = this.$store.state.users.me.admin;
    }
  };
</script>